import appSetup from '@/commons/utils/appSetup';

appSetup({
  components: {
    LandingView: () =>
      import(
        /* webpackChunkName: "landing-view" */ '@/volaris/subscriptions/views/LandingView.vue'
      ),
    PageLayout: () =>
      import(
        /* webpackChunkName: "page-layout" */ '@/commons/views/PageLayout.vue'
      ),
    PlansView: () =>
      import(
        /* webpackChunkName: "plans-view" */ '@/volaris/subscriptions/views/PlansView.vue'
      ),
    SiteHeader: () =>
      import(
        /* webpackChunkName: "site-header" */ '@/volaris/subscriptions/components/Header.vue'
      ),
    SiteFooter: () =>
      import(
        /* webpackChunkName: "footer" */ '@/volaris/subscriptions/components/Footer.vue'
      ),
    PrivatePageView: () =>
      import(
        /* webpackChunkName: "private-page-view" */ '@/volaris/subscriptions/views/PrivatePageView.vue'
      ),
    CustomizeView: () =>
      import(
        /* webpackChunkName: "customize-view" */ '@/volaris/subscriptions/views/CustomizeView.vue'
      ),
    RegisterView: () =>
      import(
        /* webpackChunkName: "register-view" */ '@/volaris/subscriptions/views/RegisterView.vue'
      ),
    PaymentView: () =>
      import(
        /* webpackChunkName: "payment-view" */ '@/volaris/subscriptions/views/PaymentView.vue'
      ),
    PaymentSuccessView: () =>
      import(
        /* webpackChunkName: "payment-success-view" */ '@/volaris/subscriptions/views/PaymentSuccessView.vue'
      ),
  },
});
